import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CMS_CAROUSEL_ROUTE } from '~app/modules/filters/constants';
import { CAROUSEL_CONFIG_HOME } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class CarouselService {
  constructor(private readonly http: HttpClient) {}

  getCarouselConfig(carouselKey: any): Observable<any> {
    return carouselKey.payload === CAROUSEL_CONFIG_HOME
      ? this.http.get(`${API_CMS_CAROUSEL_ROUTE()}/${carouselKey.payload}`)
      : this.http.get(`${API_CMS_CAROUSEL_ROUTE()}/pdp/${carouselKey.payload}`);
  }
}
